import { Nullable, Undefinedable } from "@/api/ApiClient";

export type BuyInvoicePaymentFormData = Undefinedable<Nullable<{
    id: string | undefined,
    descripcion: string,
    monto: number,
    vuelto: number,
    formaPago: string,
    digitosTarjeta: string,
    numAprobacion: string,
    estado: string,
    exchange_rate: number,
    created: string,
    recibo: string,
    cobrador: string,
    providerRecibeId: string,
    currencyId: string,
    currency: any,
    bankAccountId: string,
    creditOperatorId: string,
    buyInvoiceId: string,
    buyInvoice: any,
}>>;

export const BuyInvoicePaymentRelatedAttributes: Array<keyof BuyInvoicePaymentFormData> = ["buyInvoice", "currency"];